import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';

import { GoogleMapsService } from '../../../core/services';

@Component({
  selector: 'app-address-input',
  templateUrl: './address-input.component.html',
})
export class AddressInputComponent implements OnInit {
  @Input() form: FormGroup;

  lookup: boolean;
  lookupControl = new FormControl();
  suggestions: google.maps.places.AutocompletePrediction[];

  private autocompleteService: google.maps.places.AutocompleteService;
  private placeService: google.maps.places.PlacesService;

  constructor(
    private cd: ChangeDetectorRef,
    private googleMaps: GoogleMapsService,
  ) {}

  ngOnInit() {
    // If the form is already filled, show expanded view
    this.lookup = ! this.form.valid;

    // Get the google maps API and create required services
    this.googleMaps.api.subscribe(api => {
      this.autocompleteService = new api.places.AutocompleteService();
      this.placeService = new api.places.PlacesService(document.createElement('div'));
    });

    // Watch for lookup input changes
    this.lookupControl.valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => !! value),
    ).subscribe(value => this.autocompleteService.getPlacePredictions({
      componentRestrictions: {
        country: 'au'
      },
      input: value,
      types: ['geocode'],
    }, this.showSuggestions));
  }

  select(suggestion: google.maps.places.AutocompletePrediction) {
    this.placeService.getDetails({ placeId: suggestion.place_id }, this.setAddress);
  }

  private showSuggestions = (suggestions: google.maps.places.AutocompletePrediction[]) => {
    this.suggestions = suggestions;

    // Google maps execute outside of Angular
    this.cd.detectChanges();
  }

  private setAddress = (place: google.maps.places.PlaceResult) => {
    // Fill form (really gotta find a less ugly way to write this)
    this.form.patchValue({
      unit: (place.address_components.find(component => component.types[0] === 'subpremise') || <any>{}).short_name,
      street_number: (place.address_components.find(component => component.types[0] === 'street_number') || <any>{}).short_name,
      street: (place.address_components.find(component => component.types[0] === 'route') || <any>{}).long_name,
      suburb: (place.address_components.find(component => component.types[0] === 'locality') || <any>{}).long_name,
      state: (place.address_components.find(component => component.types[0] === 'administrative_area_level_1') || <any>{}).short_name,
      postcode: (place.address_components.find(component => component.types[0] === 'postal_code') || <any>{}).short_name,
    });

    // Close autocomplete
    this.lookup = false;
    this.lookupControl.reset();
    this.suggestions = null;

    // Google maps execute outside of Angular
    this.cd.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/address/address-input.component.ts